import Registry from '../registry'
import React from 'react'

const hidden = {
  name: 'Hidden',
  group: 'Basic',
  options: {
    default_value: {label: 'Default Value'},
    display: {
      label: 'Display',
      type: 'string',
      allowedValues: {hidden: 'Hidden', readonly: 'Read-only'},
      nullOption: false
    }
  },
  schema: part => ({
    type: 'string',
    component: ({ value }) => {
      if (part.display === 'readonly') {
        return <input type='text' value={value} readOnly />
      } else {
        return <input type='hidden' value={value} />
      }
    }
  })
}

Registry.register('hidden', hidden)

export default hidden



// WEBPACK FOOTER //
// ./app/parts/hidden.js